import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import { createProps, getClass } from "../../utils";
var classMap = {
  xs: "col-xs",
  sm: "col-sm",
  md: "col-md",
  lg: "col-lg",
  xl: "col-xl",
  xsOffset: "col-xs-offset",
  smOffset: "col-sm-offset",
  mdOffset: "col-md-offset",
  lgOffset: "col-lg-offset",
  xlOffset: "col-xl-offset"
};
var hiddenMap = {
  xs: "hidden-xs",
  sm: "hidden-sm",
  md: "hidden-md",
  lg: "hidden-lg",
  xl: "hidden-xl",
  xsHidden: "hidden-xs",
  smHidden: "hidden-sm",
  mdHidden: "hidden-md",
  lgHidden: "hidden-lg",
  xlHidden: "hidden-xl"
};

var getColClassNames = function getColClassNames(props) {
  var extraClasses = [];

  if (props.className) {
    extraClasses.push(props.className);
  }

  if (props.first) {
    extraClasses.push(getClass("first-".concat(props.first)));
  }

  if (props.last) {
    extraClasses.push(getClass("last-".concat(props.last)));
  }

  return Object.keys(props).filter(function (key) {
    return classMap[key];
  }).map(function (key) {
    var isColZero = props[key] === 0;
    var isColHidden = key.includes("Hidden");

    if (isColZero || isColHidden) {
      return getClass(hiddenMap[key]);
    }

    if (Number.isInteger(props[key])) {
      return getClass("".concat(classMap[key], "-").concat(props[key]));
    }

    return getClass(classMap[key]);
  }).concat(extraClasses);
};

export var getColumnProps = function getColumnProps(props) {
  return createProps(props, getColClassNames(props));
};
export default function Col(props) {
  var as = props.as,
      columnProps = _objectWithoutProperties(props, ["as"]);

  return /*#__PURE__*/React.createElement(as || "div", getColumnProps(columnProps));
}